import React, {Component} from 'react';
import Card from '../edit-page/Card';
import History from '../common/History';
import Assets from '../../Assets';
import buildResourcePath from '@lib/buildResourcePath';
import HelpSystemInformation from '../common/HelpSystemInformation';

export default class CustomerHistory extends Component {
    showAllClick = () => {
        window.location.href = buildResourcePath(`CustomerAudit/Index?id=${this.props.customerId}&entityTypeName=Customer&title=${this.props.title}`)
    }

    renderCustomButton = () => {
        return (
            <a onClick={() => this.showAllClick()} className="btn-show-all">{__('Show all')}</a>
        );
    }

    renderTitle = () => {
        return (
            <div className="card-title">
                <div className="title">
                    <span>{__('Customer changes history')}</span>
                    <HelpSystemInformation text={this.props.helpInfo}/>
                </div>
                <div className="card-buttons">
                    {this.renderCustomButton()}
                </div>
            </div>
        )
    }

    render() {
        return (
            <Card className="history-card" customTitle={() => this.renderTitle()}>
                <History items={this.props.editInformation.audits}/>
            </Card>
        )
    }
}